<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import CardActivityComposer from './CardActivityComposer.vue';
import CardCommentList from './CardCommentList.vue';
import CardHistory from './CardHistory.vue';

const props = defineProps({
  card: { type: Object, required: true },
  activities: { type: Array, required: true },
  // Takes { content, files }; see CardActivityComposer.
  addComment: { type: Function, required: true },
  // Take the comment's id (and the new text); see useCardDetail.
  editComment: { type: Function, required: true },
  deleteComment: { type: Function, required: true },
});

const { t } = useI18n();

// The agents' conversation about the card comes first; its history, an audit of every change,
// is one click away. More tabs can join them.
const comments = computed(() =>
  props.activities.filter(activity => activity.kind === 'comment')
);

const tabs = computed(() => [
  {
    key: 'comments',
    label: t('CARDS.SHOW.COMMENTS'),
    count: comments.value.length,
  },
  { key: 'history', label: t('CARDS.SHOW.HISTORY') },
]);
const activeTab = ref('comments');
const activeIndex = computed(() =>
  tabs.value.findIndex(tab => tab.key === activeTab.value)
);
</script>

<template>
  <section class="flex flex-col gap-4" data-testid="card-activity">
    <TabBar
      :tabs="tabs"
      :initial-active-tab="activeIndex"
      @tab-changed="tab => (activeTab = tab.key)"
    />
    <div
      v-if="activeTab === 'comments'"
      class="flex flex-col gap-4"
      data-testid="card-comments"
    >
      <CardCommentList
        :comments="comments"
        :edit-comment="editComment"
        :delete-comment="deleteComment"
      />
      <CardActivityComposer :add-comment="addComment" />
    </div>
    <CardHistory v-else :card="card" :activities="activities" />
  </section>
</template>
